import { createApiAction } from "helpers/api";

export const updateProfileStep = createApiAction({
  method: "PUT",
  endpoint: () => `/onboarding/profile`,
  baseType: `/ONBOARDING/PROFILE`,
});
